import { url } from "../redux/config";

/**
 * Resolves whatever the image-upload API returns into a usable src.
 *
 * Uploads that land in object storage come back as an absolute URL (the store
 * video already does: fofo-video-upload.in-maa-1.linodeobjects.com/...). Those
 * must be kept whole — prefixing the API host produces a link to an image the
 * API does not serve. A bare filename keeps the original /image/<name> form.
 */
export const toImageUrl = (data) => {
  const value = String(data ?? "");
  if (!value) return "";
  return /^https?:\/\//i.test(value) ? value : `${url}/image/${value}`;
};
